import { render } from "./list.vue?vue&type=template&id=f156557e&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"

import "./list.vue?vue&type=style&index=0&id=f156557e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f156557e"

export default script